import { Box } from '@mui/material'
import { AccountsPayableAllocation } from 'models/AccountsPayable'

import { Table } from 'components/Table'

import { formatMoney } from 'utils'

interface ExpenseAllocationsProps {
  allocations: AccountsPayableAllocation[]
}

const ExpenseAllocations = ({ allocations }: ExpenseAllocationsProps) => {
  return (
    <Box>
      <Box maxHeight="160px" overflow="auto">
        <Table
          mobileCards
          header={[
            { id: 'costCenter', label: 'Centro de custo' },
            { id: 'category', label: 'Categoria' },
            { id: 'amount', label: 'Valor' },
            { id: 'percentage', label: '%' }
          ]}
          hoverInRow
          rows={allocations.map((allocation) => ({
            costCenter: allocation.costCenter?.name || '-',
            category: allocation.category?.name || '-',
            amount:
              allocation.amount != null ? formatMoney(allocation.amount) : '-',
            percentage: `${Number(allocation.percentage || 0).toFixed(2)}%`
          }))}
          select={{ useSelect: false }}
          hiddePagination
        />
      </Box>
    </Box>
  )
}

export default ExpenseAllocations
